import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
Container,
Col,
Row
} from "reactstrap"
import Datatables from "../utils/table/datatable";
import { MisReportsColumns } from "helpers/DatatableColumns";
import cookieHelper from "helpers/getCookieData";
import { get } from "helpers/api_helper";
import { REPORTS } from "helpers/url_helper";
import moment from "moment";

const ScheduledTracking = () => {
    const [dataRows, setDataRows] = useState([]);

    const fetchData = async() => {
        const { success, data } = await get(`/track/getSchedule`);
        if(success){
            if(data.length == 0){
                const { success, data } = await get(`/track/all`);
                if(success){
                    setDataRows(data)
                }
            }
            setDataRows(data)
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    const Columns = [
        {
            dataField: 'id',
            text: '#',
            formatter: (cell, row, rowIndex, formatExtraData) => rowIndex + 1,
        }, {
            dataField: 'courier',
            text: 'Courier'
        }, {
            dataField: 'tracking_no',
            text: 'Live Tracking No'
        }, {
            dataField: 'sheduled_at',
            text: 'Scheduled Time',
            formatter: (cell, row, rowIndex, formatExtraData) => moment(cell).format('DD-MM-Y HH:mm:ss')
        }
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Tracking Status | {process.env.REACT_APP_TITLE}</title>
                </MetaTags>
                <Container fluid>
                    <h5 className="mb-2">Tracking Shedules</h5>
                    <Row>
                        <Col>
                            <Datatables 
                                isSearch={true}
                                columns = {Columns}
                                showTableOnly={true}
                                rowsLength={dataRows?.length || 0}
                                rows = {dataRows || []}
                                keyField={'id'}
                                handleAddButton={() => {}}            
                                title = {`Scheduled Trackings`}
                                loading = {false}
                                isAdd = {false}
                                isTableHead = {false}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ScheduledTracking;
